import Wordmark from "@/components/shared/Wordmark";
import PublicFooter from "@/components/public/PublicFooter";

/**
 * The frame for focused sign-in and activation pages: the wordmark, one
 * narrow column, and the quiet footer.
 */
export default function AuthShell({ children, helpHref }) {
  return (
    <div className="flex min-h-screen flex-col">
      <main id="main" className="flex flex-1 items-center justify-center px-4 py-12">
        <div className="w-full max-w-md">
          <div className="mb-8 text-center">
            <Wordmark className="text-2xl" />
          </div>
          {children}
        </div>
      </main>
      <PublicFooter helpHref={helpHref} />
    </div>
  );
}
